module.exports = __webpack_public_path__ + "img/guest.b81c91f4.png";